import { Switch } from '@material-ui/core'
import { useStyles } from './style'
export function InputSwitch({ label, ...rest }) {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      <Switch {...rest} size="small" name={label} id={label} />
      <label htmlFor={label}>{label}</label>
    </div>
  )
}
